import { ReactNode } from 'react';
import type { PaymentMethodV2 } from 'state/internal/getSubscriptionDetails/types';
import {
  AmericanExpressIcon,
  ApplePayIcon,
  CardLogoIcon,
  DinersClubIcon,
  DiscoverIcon,
  GooglePayIcon,
  JSBIcon,
  MasterCardIcon,
  PayPalIcon,
  ShopPayIcon,
  VenmoIcon,
  VisaIcon,
  UnionPayIcon,
  SepaIcon
} from '@ag1/ui';

export const iconCreditCard: { [key: string]: ReactNode } = {
  VISA: <VisaIcon />,
  MASTERCARD: <MasterCardIcon />,
  'AMERICAN EXPRESS': <AmericanExpressIcon />,
  AMEX: <AmericanExpressIcon />,
  PAYPAL: <PayPalIcon />,
  VENMO: <VenmoIcon />,
  JCB: <JSBIcon />,
  UNIONPAY: <UnionPayIcon />,
  DISCOVER: <DiscoverIcon />,
  DINERS: <DinersClubIcon />,
  'DINERS CLUB': <DinersClubIcon />,
  GOOGLEPAY: <GooglePayIcon />,
  APPLEPAY: <ApplePayIcon />,
  SEPA: <SepaIcon />,
  CARDLOGO: <CardLogoIcon />,
  MISSING: null
};

export const iconCreditCardSquare: { [key: string]: ReactNode } = {
  PAYPAL: <PayPalIcon />,
  APPLEPAY: <ApplePayIcon />,
  VENMO: <VenmoIcon />,
  CARDLOGO: <CardLogoIcon />,
  SHOPPAY: <ShopPayIcon />
};

export const paymentTypeV2Check = (paymentMethod: PaymentMethodV2) => {
  // checking if paypal_account_email is nullish is not enough
  // as paypal_account_email can either be a legitmate email or null
  // the check is against if paypal_account_email exists as a field
  if (
    paymentMethod?.source === 'paypal' ||
    Object.prototype.hasOwnProperty.call(paymentMethod, 'paypal_account_email')
  )
    return 'paypal';
  if (paymentMethod?.wallet === 'APPLE_PAY') return 'applePay';
  if (
    paymentMethod?.wallet === 'SHOPIFY_PAY' ||
    (!Object.prototype.hasOwnProperty.call(paymentMethod, 'source') &&
      !Object.prototype.hasOwnProperty.call(paymentMethod, 'brand'))
  )
    return 'shopPay';
  if (paymentMethod?.source === 'credit_card') return 'card';

  return 'card';
};
